export enum ActiveState {
  activeOnly = 'activeOnly',
  activeAndInactive = 'activeAndInactive',
}

export const activeFilterOptions = [
  { label: 'Only active', value: ActiveState.activeOnly },
  { label: 'Active and inactive', value: ActiveState.activeAndInactive },
];
